import "./TriviaIntro.scss";

import { FC } from "react";
import { Helmet } from "react-helmet-async";

import rocketship from "assets/images/trivia/rocketship.svg";
import Text from "components/Text/Text";
import { useTranslation } from "modules";

const TriviaIntro: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="trivia-intro__container">
      <Helmet>
        <link rel="preload" as="image" href={rocketship} />
      </Helmet>

      <Text className="trivia-intro__text trivia-intro__text--lets-play" tag="h1-header">
        {t("trivia.intro.rando", "Let's get started!")}
      </Text>

      <img className="trivia-intro__rocketship" src={rocketship} />
    </div>
  );
};

export default TriviaIntro;
